<template>
  <data-list :table-style="{ name: 'webclient' }"
             :data="data"
             :columns="column"
             :loading="loading"
             :page="page"
             :page-size="page.pageSize"
             @page-size-changed="pageSizeChanged"
             @page-changed="pageChanged"
             @sort-change="sortChange">
  </data-list>
</template>

<script>
import listPageCreate from "@/mixins/listPageCreate";
import api from "@/backend/apiConfig/apiConfig";
import visitorSer from '@/backend/services/visitor/index.js'
import jumpLink from '@/components/website/jumpLink'

const list = listPageCreate({
  searchConfig: {
    api: api.visitor.visitorStaffList,
    method: "POST"
  },
  getQuery (data, that) {
    return _.assign(data, {
      type: that.name,
      visitorId: that.visitorId
    })
  }
});
export default {
  mixins: [list],
  props: {
    name: {},
    index: {},
    visitorId: {}
  },
  data () {
    return {
      column: []
    }
  },
  methods: {
    setColumn () {
      let colMap = {
        prospect: [
          {
            width: 10
          },
          {
            label: '客户名称',
            bind: 'staffName',
            showOverflowTooltip: true
          },
          {
            label: '客户邮箱',
            bind: 'email',
            showOverflowTooltip: true
          },
          {
            label: '职位',
            bind: 'position',
            showOverflowTooltip: true
          },
          {
            label: '社交媒体地址',
            type: 'custom',
            componentName: jumpLink,
            isProtocol: true,
            bind: 'sourcePage',
          },
        ],
        email: [
          {
            width: 10
          },
          {
            label: '客户邮箱',
            bind: 'email',
          },
        ]
      }
      this.column = colMap[this.name]
    }
  },
  mounted () {
    this.setColumn()
    this.query()
  },
  watch: {
    'page.totalRecords': {
      deep: true,
      immediate: true,
      handler (val) {
        this.$emit('total-records', val, this.index)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>